//const URI =  'http://localhost:5000/';
// const URI =  'https://softronikx.info/haideritrustsystem/server/';

//const BASE = "http://localhost:3000/";
// const BASE =  'https://softronikx.info/haideritrustsystem/';
// API
const URI = '/';

// Frontend base
const BASE = '/';

const API_URL = {

    'GET_ALL_STATES': URI + 'api/state/',
    'GET_ALL_CITIES': URI + 'api/city/',

    'POST_ADMIN_LOGIN': URI + 'api/adminuser/login',

    'POST_CREATE_RELIGION': URI + 'api/religion/',
    'GET_ALL_RELIGION': URI + 'api/religion/',
    'DELETE_SINGLE_RELIGION': URI + 'api/religion/',

    'POST_CREATE_CASTE': URI + 'api/caste/',
    'GET_ALL_CASTE': URI + 'api/caste/',
    'GET_CASTE_BY_RELIGION': URI + 'api/caste/',
    'DELETE_SINGLE_CASTE': URI + 'api/caste/',

    'GET_ALL_SUBCASTE': URI + 'api/subcaste/',
    'POST_CREATE_SUBCASTE': URI + 'api/subcaste/',
    'DELETE_SINGLE_SUBCASTE': URI + 'api/subcaste/',
    'GET_SUBCASTE_BY_CASTE': URI + 'api/subcaste/',

    'POST_CREATE_STUDENT': URI + 'api/student/register',
    'POST_STUDENT_LOGIN': URI + 'api/student/login',
    'GET_SINGLE_STUDENT_BY_EMAIL': URI + 'api/student/email',
    'GET_SINGLE_STUDENT_BY_ID': URI + 'api/student/',
    'GET_PUBLIC_SINGLE_STUDENT_BY_ID': URI + 'api/student/public/',
    'PATCH_SINGLE_STUDENT': URI + 'api/student',
    'PATCH_STUDENT_ADMIN_STATUS': URI + 'api/student/admin/updatestatus',
    'PROFILE_PICTURE_URL': URI + '',
    'SEARCH_STUDENT': URI + 'api/student/search',

    'POST_STUDENT_DOCUMENT': URI + 'api/studentdocument/uploaddata',
    'GET_STUDENT_DOCUMENT' : URI + 'api/studentdocument',
    'GET_ADMIN_STUDENT_DOCUMENT' : URI + 'api/studentdocument/admin',

    'GET_ALL_STUDENTS': URI + 'api/student/',

    'DOCUMENT_URL': URI + '',

    'GET_BASE': BASE,
}

Object.freeze(API_URL);

export default API_URL;